import React, {Component} from 'react';
import MemberHeader from '../../components/MemberHeader';

class Error404 extends Component {
    render() {
        return (
            <React.Fragment>
                <MemberHeader customLabel={"SHS-ADCAA"} />
                <center className="page_not_found">
                    <h1 style={{fontSize: 120}}>404</h1>
                    <hr/>
                    <h3>PAGE NOT FOUND</h3>
                </center>
            </React.Fragment>
        );
    }
}

export default Error404;